"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Random = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Get a cryptographically secure random string or number
var Random = exports.Random = /*#__PURE__*/function () {
  function Random() {
    _classCallCheck(this, Random);
  }
  return _createClass(Random, null, [{
    key: "randomString",
    value:
    // Random String of alphanumeric values, A-Z or 0-9
    function randomString(digits) {
      if (digits < 1) return "";
      var randomArray = new Uint8Array(digits);
      window.crypto.getRandomValues(randomArray); // fill with random unisgned values

      var randomString = "";
      for (var i = 0; i < digits; i++) {
        var charCode = randomArray[i] % 36; // modulo to get 36 possible characters (10 digits + 26 letters)
        if (charCode < 10) randomString += charCode; // number coerced into a string
        else randomString += String.fromCharCode(charCode + 55); // 55 is the offset to get from 10-35 to 'A'-'Z'
      }
      return randomString;
    }

    // Random number with the specified number of digits (no leading zeroes)
  }, {
    key: "randomNumber",
    value: function randomNumber(digits) {
      if (digits < 1) return Number.NaN;

      // Get a cryptographically secure random string
      var randomArray = new Uint8Array(digits);
      window.crypto.getRandomValues(randomArray);
      var randomString = "";

      // Ensure the first digit is not zero
      var firstDigit = randomArray[0] % 9 + 1; // 1-9
      randomString += firstDigit;

      // Generate the remaining digits
      for (var i = 1; i < digits; i++) {
        var val = randomArray[i] % 10; // 0-9
        randomString += val;
      }

      // Convert the string to a number
      return Number(randomString);
    }
  }]);
}();